import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components aur Pages import
import Navbar from "./Components/Navbar/Navbar"; 
import Home from "./Pages/Home"; 
// import ScrollTop from './Components/ScrollTop'; 

// Footer Import
import Footer from "./Components/Footer/Footer"; 

import "./App.css";

function App() {
  return (
    <Router>
      <Navbar />
      
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>

      {/* Footer yahan add kiya gaya hai taaki ye har page ke bottom mein dikhe */}
      <Footer />

      {/* ScrollToTop globally hamesha active rahega */}
      {/* <ScrollTop /> */}
      
    </Router>
  );
}

export default App;